module.exports = __webpack_public_path__ + "media/images/icons/people-group-gray-icon-15e808be655505c2df5abf2dbb27f196.svg";